// How the team table words a timestamp. Beside the page rather than in it,
// so the page file exports its component and nothing else.

const DATE_FMT = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

/** Compact relative time: "just now", "2h ago", "1d ago", or "Apr 22". */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diffMs = Date.now() - d.getTime();
  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return DATE_FMT.format(d);
}

/**
 * Humanise a duration until a future ISO timestamp.
 * "today", "in 70h", "in 3d", "in 2 weeks" etc — used for invite expiry meta.
 * Returns { text, isClose } where isClose is true when < 24h to expiry.
 */
export function humaniseExpiresIn(iso: string): {
  text: string;
  isClose: boolean;
  expired: boolean;
} {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return { text: "—", isClose: false, expired: false };
  }
  const diffMs = d.getTime() - Date.now();
  if (diffMs <= 0) return { text: "expired", isClose: true, expired: true };
  const min = Math.floor(diffMs / 60000);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);
  const isClose = hr < 24;
  let text: string;
  if (min < 60) text = `expires in ${min}m`;
  else if (hr < 48) text = `expires in ${hr}h`;
  else if (day < 14) text = `expires in ${day}d`;
  else text = `expires in ${Math.floor(day / 7)}w`;
  return { text, isClose, expired: false };
}
